'use client'
import React, { useRef, useState } from 'react'

export interface FileUploadProps {
  label?: string
  accepted?: string
  onFileChange: (file: File | null) => void
}

export const FileUpload: React.FC<FileUploadProps> = ({
  label = 'Upload File',
  accepted = '*',
  onFileChange,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [file, setFile] = useState<File | null>(null)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = (e.target.files && e.target.files[0]) || null
    setFile(selected)
    if (onFileChange) onFileChange(selected)
  }

  return (
    <div>
      <div className='card card-uploader' onClick={() => fileInputRef.current?.click()}>
        <div className='card-body text-center'>
          <input
            type='file'
            accept={accepted}
            ref={fileInputRef}
            onChange={handleChange}
            style={{ display: 'none' }}
          />
          <svg
            width='20'
            height='18'
            viewBox='0 0 24 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M15.7553 13.7475L11.7553 9.74754M11.7553 9.74754L7.75533 13.7475M11.7553 9.74754V18.7475M20.1453 16.1375C21.1207 15.6058 21.8912 14.7644 22.3352 13.7462C22.7792 12.7279 22.8715 11.5908 22.5975 10.5142C22.3235 9.43769 21.6988 8.48305 20.822 7.80099C19.9452 7.11892 18.8662 6.74828 17.7553 6.74754H16.4953C16.1926 5.57678 15.6285 4.48988 14.8453 3.56854C14.0621 2.64719 13.0802 1.91539 11.9734 1.42815C10.8667 0.940907 9.66388 0.710901 8.45545 0.755425C7.24701 0.799948 6.0644 1.11784 4.99651 1.68521C3.92862 2.25257 3.00324 3.05465 2.28995 4.03112C1.57666 5.0076 1.09402 6.13308 0.878311 7.32294C0.662601 8.51279 0.719437 9.73607 1.04454 10.9008C1.36965 12.0655 1.95457 13.1414 2.75533 14.0475'
              stroke='#000076'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          <div className='ms-2'>
            {file ? <strong>{file.name}</strong> : 'Drag files here or click to upload'}
          </div>
        </div>
      </div>{' '}
      {file && (
        <div className='upload-preview'>
          📎 <strong>{file.name}</strong> attached
        </div>
      )}
    </div>
  )
}
